import { render, staticRenderFns } from "./StatsSchoolDialog.vue?vue&type=template&id=3803bdb9&scoped=true&"
import script from "./StatsSchoolDialog.vue?vue&type=script&lang=js&"
export * from "./StatsSchoolDialog.vue?vue&type=script&lang=js&"
import style0 from "./StatsSchoolDialog.vue?vue&type=style&index=0&id=3803bdb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3803bdb9",
  null
  
)

export default component.exports